import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Box,
  IconButton,
  Button,
  Modal,
  Typography,
  TextField,
} from "@mui/material";
import Api from "../api/Api";
import { BASE_API_URL, version } from "../api/const";
import moviesStore from "../stores/moviesStore";
import { observer } from "mobx-react-lite";

const Header: React.FC = observer(() => {
  const navigate = useNavigate();
  const userString: string | null = localStorage.getItem("mediateka.Login");

  const [open, setOpen] = useState(false);

  useEffect(() => {
    // При открытии читаем актуальный лимит из store (он сам подтянул из localStorage в конструкторе)
    if (open) {
      const savedLimit = localStorage.getItem("mediateka.Limit");
      if (savedLimit) {
        moviesStore.setLimit(Number(savedLimit));
      }
    }
  }, [open]);

  const handleLogout = async (): Promise<void> => {
    try {
      // Отправляем запрос на /user/logout
      await Api.post(`${BASE_API_URL}/user/logout`, {});

      // Очищаем localStorage
      localStorage.removeItem("mediateka.Login");
      localStorage.removeItem("mediateka.Token");
      localStorage.removeItem("mediateka.Limit");

      // Перенаправляем пользователя на страницу авторизации
      navigate("/auth");
    } catch (error) {
      console.error("Ошибка при выходе:", error);
    }
  };

  const handleChange = (value: string) => {
    let num = Number(value);
    if (isNaN(num)) return;

    // ограничение от 1 до 48
    if (num < 1) num = 1;
    if (num > 48) num = 48;

    moviesStore.setLimit(num);
  };

  const handleCloseModal = async () => {
    setOpen(false);
    moviesStore.fetchMovies(1);
  };

  return (
    <header
      style={{
        height: "20px",
        marginBottom: 10,
        padding: "5px",
        backgroundColor: "#1976d2",
        color: "#fff",
        fontSize: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        {/* Левая часть: Иконка "домой" и ссылки */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            <IconButton>
              <HomeIcon sx={{ color: "#E0F7FA", fontSize: "25px" }} />
            </IconButton>
          </Link>

          <span
            style={{
              fontSize: "12px",
              marginRight: "auto",
              marginLeft: "20px",
            }}
          >
            {`версия ${version}`}
          </span>
          <span
            style={{
              fontSize: "12px",
              marginRight: "20px",
            }}
          >
            ({/dev/.test(BASE_API_URL) ? "dev" : "prod"})
          </span>
        </Box>

        {/* Центральная надпись */}
        <Box
          onClick={() => window.location.reload()}
          sx={{
            cursor: "pointer",
            flexGrow: 1,
            textAlign: "center",
          }}
        >
          <span
            style={{
              fontSize: "25px",
              fontWeight: "bold",
              color: "#ffffff",
            }}
          >
            Медиатека
          </span>
        </Box>

        {/* Правая часть: пользователь и кнопка "Выход" */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <span style={{ fontSize: "16px", marginRight: "auto" }}>
            {userString}
          </span>
          <IconButton onClick={() => setOpen(true)} sx={{ color: "#CCCCCC" }}>
            <SettingsIcon />
          </IconButton>
          <Button
            onClick={handleLogout}
            variant="text"
            size="small"
            sx={{
              color: "#E0F7FA",
              padding: "2px 8px",
              minWidth: "auto",
              fontSize: "10px",
              textTransform: "none",
            }}
          >
            Выход
          </Button>
        </Box>
      </Box>

      {/* Модалка */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute" as const,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
            minWidth: 300,
            textAlign: "center",
          }}
        >
          {/* Внутренний Box с отступами */}
          <Box sx={{ p: 2, backgroundColor: "#E0F7FA" }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Установите лимит строк в таблице
            </Typography>

            <Box
              sx={{
                position: "relative",
                border: "1px solid #90CAF9",
                borderRadius: "4px",
                padding: "8px",
                backgroundColor: "#E0F7FA",
                mt: 1,
                mb: 2,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  top: "-10px",
                  left: "10px",
                  backgroundColor: "#E0F7FA",
                  px: "4px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                1 - 48
              </Typography>

              <TextField
                type="number"
                value={moviesStore.limit} // 👈 берем из store
                onChange={(e) => handleChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // предотвращает сабмит формы
                    handleCloseModal();
                  }
                }}
                fullWidth
                size="small"
                inputProps={{ min: 1, max: 48 }}
                autoComplete="off"
              />
            </Box>

            <Button
              variant="contained"
              onClick={handleCloseModal}
              sx={{ minWidth: 100 }}
            >
              Закрыть
            </Button>
          </Box>
        </Box>
      </Modal>
    </header>
  );
});

export default Header;
